export class TransportExternalInformationsGroup {

  name: string;
  index: number;
  transportExternalInformationsGroupEntries = new Array<TransportExternalInformationsGroupEntry>();

  constructor(data: any) {
    if (data != null) {
      this.name = data.name;
      this.index = data.index;
      if (data.transportExternalInformationsGroupEntries != null) {
        for (const entry of data.transportExternalInformationsGroupEntries) {
          this.transportExternalInformationsGroupEntries.push(new TransportExternalInformationsGroupEntry(entry));
        }
      }
    }
  }

}

export class TransportExternalInformationsGroupEntry {

  key: string;
  value: string;
  index: number;

  constructor(data: any) {
    this.key = data?.key;
    this.value = data?.value;
    this.index = data?.index;
  }
}
